import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { rx } from '@app/shared/rx';
import { get, has } from 'lodash';

@Directive({
  selector: '[appThrottleClick]',
  standalone: false,
})
export class ThrottleClickDirective implements OnInit, OnDestroy {
  @Input()
  public throttleTimeMs: number = 1000;

  @Output()
  public throttledClick: EventEmitter<MouseEvent> = new EventEmitter();

  private clicks: Subject<MouseEvent> = new Subject();
  private subscription?: Subscription;

  public ngOnInit(): void {
    this.subscription = this.clicks
      .pipe(
        rx.throttleTime(this.throttleTimeMs),
        rx.debounceTime(0),
        rx.distinctUntilChanged(),
      )
      .subscribe((e) => this.throttledClick.emit(e));
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  public clickEvent(event: PointerEvent): void {
    if (!has(event, 'pointerType') || get(event, 'pointerType') !== '') {
      event.preventDefault();
      event.stopPropagation();
      this.clicks.next(event);
    }
  }
}
